import styled, { css } from 'styled-components'

export const StyledButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -2.5px;
    ${({ margin }) =>
        margin &&
        css`
            margin: 0 -${margin}px;
            align-items: center;
            > button {
                margin: ${margin}px ${margin}px;
                width: calc(50% - ${margin * 2}px);
            }
`};
    ${({ centered }) =>
        centered &&
        css`
            justify-content: center;
            align-items: center;
    `};
    ${({ stretch }) =>
        stretch &&
        css`
            justify-content: space-between;
            align-items: center;
    `};
`